require("./spritemaster_sprite.js");
require("./spritemaster_spriteobjectof.js");
require("./spritemaster_spriteproperty.js");
require("./spritemaster_getclonesofsprite.js");
require("./spritemaster_getclonecountofsprite.js");
require("./spritemaster_checktouchingsprite_equals_propertyvalue.js");